import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import { Button, Grid, Paper, Stack, Typography } from '@mui/material';
import React, { FunctionComponent, ReactNode } from 'react';
import { useNavigate } from 'react-router-dom';
import theme from '../../../assets/theme/theme';
import { PAGES_URLS } from '../../../lib/constants/routes';

const MeinBereichPaper: FunctionComponent<MeinBereichPaperProps> = ({ titleIcon, title, children }) => {
	const navigate = useNavigate();

	return (
		<>
			{/** TODO: use enum for title */}
			{title === 'Nachrichten' ?
				<Paper
					sx={{
						padding: '1rem 1.5rem',
						marginTop: '1rem',
						borderRadius: '8px',
						boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.2) !important',
					}}
				>
					<Stack
						direction={'row'}
						spacing={1}
						justifyContent='space-between'
						alignItems='center'
						width='100%'
						color={theme.palette.primary.main}
					>
						<Stack direction='row' alignItems='center' spacing={1}>
							{titleIcon}
							<Typography variant='h3' component='h2' sx={{ color: 'black' }}>
								{title}
							</Typography>
						</Stack>
						<Button variant='text' onClick={() => navigate(PAGES_URLS.Nachrichten)} sx={{ textDecoration: 'underline', color: 'black' }}>
							Alle anzeigen
						</Button>
					</Stack>
					<Grid container spacing={4} sx={{ marginTop: '1rem' }} alignItems={'center'}>
						{React.Children.map(children, (child, index) => (
							<Grid item xs={12} sm={6} md={4} key={index}>
								{child}
							</Grid>
						))}
					</Grid>
				</Paper>
			:	<Paper
					sx={{
						padding: '1rem 1.5rem',
						marginTop: '1rem',
						borderRadius: '8px',
						boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.2) !important',
					}}
				>
					<Stack direction={'row'} spacing={1} alignItems={'center'} color={theme.palette.primary.main}>
						{titleIcon}
						<Typography variant='h3' component='h2' sx={{ color: 'black' }}>
							{title}
						</Typography>
					</Stack>
					<Grid container spacing={4} sx={{ marginTop: '1rem' }}>
						{React.Children.map(children, (child, index) => (
							<Grid item xs={12} sm={6} md={4} key={index}>
								{child}
							</Grid>
						))}
					</Grid>
				</Paper>
			}
		</>
	);
};

const MeinBereichButton: FunctionComponent<MeinBereichButtonProps> = ({ buttonName, onClick, disabled = false, variant = 'meinBereich' }) => {
	return (
		<>
			<Button variant={variant as any} endIcon={<KeyboardArrowRightIcon />} onClick={onClick} disabled={disabled}>
				{buttonName}
			</Button>
		</>
	);
};

interface MeinBereichPaperProps {
	titleIcon?: ReactNode;
	title: string;
	children: ReactNode;
}
interface MeinBereichButtonProps {
	variant?: string;
	buttonName: string;
	onClick?: () => void;
	disabled?: boolean;
}
export { MeinBereichButton, MeinBereichPaper };
